import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import login_bg from '../assets/login_bg.jpg';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, CDN_URL, formatMoney, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import { STR_AT_LEAST_ONE_IMAGE, STR_AVAILABLE_QUANTITY, STR_CATEGORY, STR_CROPS, STR_IMAGES, STR_INVALID_LOCATION, STR_INVALID_QUANTITY, STR_INVALID_TITLE, STR_INVALID_UNIT_PRICE, STR_ITEM_DESCRIPTION, STR_ITEM_LOCATION, STR_ITEM_TITLE, STR_LIVESTOCK, STR_MOQ, STR_POST_ITEM, STR_SUBMIT, STR_SUCCESS, STR_UNIT, STR_UNIT_PRICE } from "../Strings";


export default function View({ data }) {

	const appContext = useContext(AppContext);

	const [loading, setLoading] = useState(false);
	
	function view(){
		appContext.navTo({
			item: 'view',
			subItem: 'item',
			extraItem: data.uuid,
		})
	}

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
		
		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	
	return (
		<div 
			className=""
			style={{
				width: "100%",
				marginBottom: "20px", 
				cursor: "pointer",
				border: "1px solid var(--primaryColor)",
				borderRadius: "10px",
				overflow: "hidden"
			}}
			onClick={view}
		>
			<div 
				className="bg-surface"
				style={{
					width: "100%",
					height: "200px",
					overflow: "hidden",
				}}
			>
				<img
					src={CDN_URL + (data.img1 || data.img2 || data.img3)}
					style={{
						width: "100%",
						height: "100%",
						objectFit: "cover",
						objectPosition: "center",
					}}
				/>
			</div>

			<div 
				className="bg-surface"
				style={{
					width: "100%",
					height: "130px",
					overflow: "hidden",
					padding: "10px"
				}}
			>
				{
					(data.category === 'crop') ?
					<span className="badge bg-primary">{STR_CROPS[appContext.language]}</span>
					:""
				}

				{
					(data.category === 'livestock') ?
					<span className="badge bg-secondary">{STR_LIVESTOCK[appContext.language]}</span>
					:""
				}

				<h6
					style={{
						fontSize: "18px"
					}}
					className="font-semi-bold text-primary mOneLineText"
				>
					{data.title}
				</h6>

				<h6
					style={{
						fontSize: "28px"
					}}
					className="font-semi-bold text-secondary text-end mOneLineText"
				>
					{formatMoney(data.unitPrice)} 
					<span
						style={{
							paddingLeft: "10px",
							fontSize: "20px",
						}}
					>
						TZS
					</span>
					<span
						style={{
							paddingLeft: "10px",
							fontSize: "16px",
							display: "block",
							textTransform: "uppercase"
						}}
						className="font-bold text-muted"
					>
						{data.unit}
					</span>
				</h6>

				
			</div>
			
		</div>
	)
	
}